import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import { lock, unlock } from 'tua-body-scroll-lock'

export default function initAlpine() {
  document.addEventListener('alpine:init', () => {
    Alpine.data('headerControls', () => ({
      navOpen: false,
      searchOpen: false,
      isScrollLocked: false,
      slideOutEl: null,

      init() {
        this.slideOutEl = document.querySelector('.slide-out__wrapper');
      },

      updateLockState() {
        if (!this.slideOutEl) return;

        const shouldLock = this.navOpen || this.searchOpen
        if (shouldLock && !this.isScrollLocked) {
          lock(this.slideOutEl)
          this.isScrollLocked = true
        } else if (!shouldLock && this.isScrollLocked) {
          unlock(this.slideOutEl)
          this.isScrollLocked = false
        }
      },

      toggleNav() {
        this.navOpen = !this.navOpen
        this.searchOpen = false
        this.updateLockState()
      },

      toggleSearch() {
        this.searchOpen = !this.searchOpen
        this.navOpen = false
        this.$nextTick(() => {
          this.$refs.input?.focus()
        })
        this.updateLockState()
      },
    }))

    Alpine.data('navMenu', () => ({
      activeId: null,
      toggle(id) {
        this.activeId = this.activeId === id ? null : id
      },
      getActiveId() {
        return this.activeId
      },
    }))
  })
  Alpine.plugin(collapse)
  Alpine.start()
}
